import { Component } from "@mna/react";
import Form from "@mna/react-ui/Form";
import { Trans } from "react-i18next";
import i18next from "i18next";
import schema from "@mna/schema";
import create from "assets/img/Create_img.png";
import { azureConfig } from "client.config";
import LoadingScreen from "features/LoadingScreen";
import moment from "moment-timezone";
import Modal from "react-modal";
import { classnames as cx } from "@mna/react";
import i18n from "../../i18n";

var currentEmailId;
var organizationId, oBranchId, verificationExpirationDateTime, language;

const initialState = {
	firstErrorMsg: "",
	secondErrorMsg: "",
	passwordErrorMsg: "",
	confirmErrorMsg: "",
	isLinkExpired: false,
};

class Create extends Component {
	state = initialState;

	callSetStateModal(setState, value) {
		setState({
			showExistsModal: value,
		});
	}


	async callgetIdentityApi(state, setState, actions, history, shouldRedirectToNextPage) {

		var identities = await actions.callExternalIndentities(
			state,
			setState,
			actions
		);

		if (identities !== undefined) {

			if (identities && identities.response.results.length >= 1) {
				this.callSetStateModal(setState, true);
			} else {
				this.callSetStateModal(setState, false);
				setState({
					isLoading: false,
				});
				if (shouldRedirectToNextPage) {
					history.push("/create-details");
				}
			}
		}
	}

	checkAndReturnQueryParam(value) {
		var hasValue = new URLSearchParams(this.props.location.search).has(value);
		if (hasValue) {
		  return new URLSearchParams(this.props.location.search).get(value);
		} else {
		  return "";
		}
	  }

	componentWillMount() {
		const { state, setState, actions, history } = this.props;
		var searchParam = this.props.location.search;
		if (searchParam) {
			currentEmailId = searchParam.split("&")[0].split("=")[1];
			organizationId = searchParam.split("&")[1].split("=")[1];
			oBranchId = searchParam.split("&")[2].split("=")[1];
			verificationExpirationDateTime = searchParam.split("&")[3].split("=")[1];
			var tempEmailId = { email: currentEmailId.toLowerCase() };
			state.triageRequest.mailValidation = tempEmailId;
			state.triageRequest.SignUpOrganizationId = organizationId;
			state.triageRequest.SignUpOBranchId = oBranchId;
		}
		language = this.checkAndReturnQueryParam("lng");

		if (language === "") {
		  language = "en";
		}
		i18n.changeLanguage(language);
		if (typeof window !== "undefined") {
			window.sessionStorage.setItem("languageCode", language);
		  }

		var shouldRedirectToNextPage = false;

		this.callgetIdentityApi(state, setState, actions, history, shouldRedirectToNextPage);
		const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
		const currentTime = moment().tz(timezone).format("YYYY-MM-DDTHH:mm:ss");

		var startTime = new Date(verificationExpirationDateTime);
		var endTime = new Date(currentTime);

		if (startTime > endTime) {
			//session is there
			this.setState({
				isLinkExpired: false,
			});
		} else {
			//session is not there
			this.setState({
				isLinkExpired: true,
			});
		}
	}

	async callSendMail(state, actions, setState, emailId) {
		var isEmailSent = await actions.sendMailConfirmation(
			state,
			setState,
			actions,
			emailId,
			organizationId,
			oBranchId,
			language
		);
		setState({
			isLoading: false,
		});
		this.setState({
			isMailSent: isEmailSent,
		});
	}

	render() {
		const {
			state,
			state: { triageRequest },
			history,
			setState,
			actions,
		} = this.props;

		const formSchema = schema(({ string }) => ({
			first: string,
			last: string,
			password: string,
			confirmPassword: string,
		}));

		return (
			<div className="page-section-2">
				{!this.state.isLinkExpired ? (
					<Form
						className="content content-unset"
						fields={triageRequest.serviceRequest}
						onValidate={(data) => {
							const errors = {};

							var scheme = formSchema(data);
							var enteredPassword = data.password;

							if (scheme !== null && scheme.first === "REQUIRED")
								errors.first = "REQUIRED";

							if (scheme !== null && scheme.last === "REQUIRED")
								errors.last = "REQUIRED";

							if (scheme !== null && scheme.password === "REQUIRED") {
								errors.password = "REQUIRED";
							}
							if (data.password === "") {
								passwordError = (
									<Trans i18nKey="userregistration.validation.pwd">
										Password cannot be empty
									</Trans>
								);
								errors.password = "REQUIRED";
							} else if (
								/^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/.test(
									enteredPassword
								) === false
							) {
								passwordError = (
									<Trans i18nKey="userregistration.validation.pwd1">
										Your password must be at least 8 characters long, contain at
										least one number,one Special character and have a mixture of
										uppercase and lowercase letters;
									</Trans>
								);
								errors.password = "REQUIRED";
							} else {
								passwordError = "";
							}
							this.setState({ passwordErrorMsg: passwordError });

							if (scheme !== null && scheme.confirmPassword === "REQUIRED") {
								errors.confirmPassword = "REQUIRED";
							}

							if (data.confirmPassword === "") {
								confirmPass = (
									<Trans i18nKey="userregistration.validation.confo_pwd1">
										Confirm password cannot be empty
									</Trans>
								);
								errors.confirmPassword = "REQUIRED";
							}
							else if (enteredPassword !== data.confirmPassword) {
								confirmPass = (
									<Trans i18nKey="userregistration.validation.confo_pwd2">
										Password and confirm password does not match
									</Trans>
								);
								errors.confirmPassword = "REQUIRED";
							} else {
								confirmPass = "";
							}
							this.setState({ confirmErrorMsg: confirmPass });

							let firstError = "";
							let secondError = "";
							let passwordError = "";
							let confirmPass = "";

							if (data.first === "") {
								firstError = (
									<Trans i18nKey="userregistration.validation.firstname">
										First name cannot be empty
									</Trans>
								);
								errors.first = "REQUIRED";
							} else if (data.first.trim().length < 1) {
								firstError = (
									<Trans i18nKey="userregistration.validation.firstname_msg1">
										Enter the valid first name
									</Trans>
								);
								errors.first = "REQUIRED";
							}
							this.setState({ firstErrorMsg: firstError });

							if (data.last === "") {
								secondError = (
									<Trans i18nKey="userregistration.validation.lastname">
										Last name cannot be empty
									</Trans>
								);
								errors.last = "REQUIRED";
							} else if (data.last.trim().length < 1) {
								secondError = (
									<Trans i18nKey="userregistration.validation.lastname1">
										Enter the valid last name
									</Trans>
								);
								errors.last = "REQUIRED";
							}
							this.setState({ secondErrorMsg: secondError });

							if (Object.keys(errors).length) return errors;
						}}
						onSubmit={(data) => {
							state.triageRequest.createUser = data;
							var shouldRedirectToNextPage = true;
							this.callgetIdentityApi(state, setState, actions, history, shouldRedirectToNextPage);

						}}
					>
						{({ fields, invalidFields }) => (
							<div className="container-2 w-container">
								<LoadingScreen isLoading={state.isLoading}>
									<div className="w-row">
										<div className="column w-col w-col-1 w-col-tiny-tiny-stack"></div>
										<div className="column-2 w-col w-col-5 w-col-tiny-tiny-stack">
											<div>
												<p className="mb-4">
													<Trans i18nKey="userregistration.verification-msg">
														Thank you for verifying your email, let's set up
														your profile.
													</Trans>
												</p>
												<div>
													<div className="column-2 w-col w-col-6 w-col-tiny-tiny-stack">
														<input
															id="firstname-input"
															name="first"
															type="text"
															autoComplete="off"
															defaultValue={
																state.triageRequest.createUser &&
																	state.triageRequest.createUser.first
																	? state.triageRequest.createUser.first.trim()
																	: fields.first
															}
															placeholder={i18next.t(
																"userregistration.Firstname"
															)}
															className={
																invalidFields.first
																	? "is-error"
																	: "text-field w-input"
															}
														/>

														<span className="errormessage-first">
															{this.state.firstErrorMsg}
														</span>
													</div>
													<div className="column-2 w-col w-col-6 w-col-tiny-tiny-stack">
														<input
															id="lastname-input"
															type="text"
															name="last"
															autoComplete="off"
															defaultValue={
																state.triageRequest.createUser &&
																	state.triageRequest.createUser.last
																	? state.triageRequest.createUser.last.trim()
																	: fields.last
															}
															placeholder={i18next.t(
																"userregistration.Lastname"
															)}
															className={
																invalidFields.last
																	? "is-error"
																	: "text-field w-input"
															}
														/>
														<span className="errormessage-first">
															{this.state.secondErrorMsg}
														</span>
													</div>
												</div>
												<div>
													<div className="column-2 w-col w-col-tiny-tiny-stack">
														<input
															id="password-input"
															type="password"
															name="password"
															autoComplete="off"
															defaultValue={
																state.triageRequest.createUser &&
																	state.triageRequest.createUser.password
																	? state.triageRequest.createUser.password.trim()
																	: fields.password
															}
															placeholder={i18next.t(
																"userregistration.Password"
															)}
															className={
																invalidFields.password
																	? "is-error"
																	: "text-field w-input"
															}
														/>
														<div className="errormessage">
															{this.state.passwordErrorMsg}
														</div>
													</div>
												</div>
												<div>
													<div className="column-2 w-col w-col-tiny-tiny-stack">
														<input
															id="password-input"
															type="password"
															name="confirmPassword"
															autoComplete="off"
															defaultValue={
																state.triageRequest.createUser &&
																	state.triageRequest.createUser.confirmPassword
																	? state.triageRequest.createUser.confirmPassword.trim()
																	: fields.confirmPassword
															}
															placeholder={i18next.t(
																"userregistration.Confirm Password"
															)}
															className={
																invalidFields.confirmPassword
																	? "is-error"
																	: "text-field w-input"
															}
														/>
														<div className="errormessage">
															{this.state.confirmErrorMsg}
														</div>
													</div>

													<div className="column-2 w-col w-col-tiny-tiny-stack">
														<div className="continue-btn">
															<button
																type="submit"
																className="button1 btn standby-button-gradient standby-button-gradient-blue"
															>
																<Trans i18nKey="userregistration.continue">
																	Continue{" "}
																</Trans>
															</button>
														</div>
														<p className="text-block-3">
															<Trans i18nKey="userregistration.cancel">
																Cancel{" "}
															</Trans>
														</p>
													</div>
												</div>
											</div>
										</div>
										<div className="w-col w-col-6 w-col-tiny-tiny-stack">
											<img src={create} className="t-img" />
										</div>
									</div>
								</LoadingScreen>
							</div>
						)}
					</Form>
				) : (
					<div className="page-section-2">
						<Form
							className="content content-unset"
							fields={triageRequest.serviceRequest}
							onValidate={(data) => {
								const errors = {};
								let emailError = "";
								var erroredEmail = data.email;
								var scheme = formSchema(data);
								if (scheme !== null && scheme.email === "REQUIRED")
									errors.email = "REQUIRED";

								if (data.email === "") {
									emailError = (
										<Trans i18nKey="userregistration.validation.email">
											Email address cannot be empty
										</Trans>
									);
									errors.email = "REQUIRED";
								} else if (
									/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test(
										erroredEmail.trim()
									) === false
								) {
									emailError = (
										<Trans i18nKey="userregistration.validation.email_msg1">
											Enter the Valid Email Address
										</Trans>
									);
									errors.email = "REQUIRED";
								}
								this.setState({ emailErrorMsg: emailError });

								if (Object.keys(errors).length) return errors;
							}}
							onSubmit={async (values) => {

								var emailId = { email: values.email.toLowerCase() };
								state.triageRequest.mailValidation = emailId;
								var identities = await actions.callExternalIndentities(
									state,
									setState,
									actions
								);
								if (identities && identities.response.results.length >= 1) {
									this.callSetStateModal(setState, true);
								} else {
									this.callSetStateModal(setState, false);
									var emailId = state.triageRequest.mailValidation.email;
									setState({
										isLoading: true,
									});
									this.callSendMail(state, actions, setState, emailId);
								}
							}}
						>
							{({ fields, invalidFields }) => (
								<div className="container-2 w-container">
									<LoadingScreen isLoading={state.isLoading}>
										{!this.state.isMailSent ? (
											<div id="inputEmail">
												<div className="column w-col w-col-1 w-col-tiny-tiny-stack"></div>
												<div className="column-2 w-col w-col-5 w-col-tiny-tiny-stack">
													<div>
														<span id="createaccount">
															<Trans i18nKey="userregistration.expired-msg">
																Your email verification link has expired. Please
																re-enter your e-mail address to receive a new
																link
															</Trans>
														</span>
														<input
															id="email-input"
															type="text"
															name="email"
															placeholder={i18next.t(
																"userregistration.emailwm"
															)}
															defaultValue={
																state.triageRequest.mailValidation &&
																	state.triageRequest.mailValidation.email
																	? state.triageRequest.mailValidation.email.trim()
																	: fields.email
															}
															className={cx(
																"text-field w-input",
																invalidFields.email ? "is-error" : ""
															)}
														/>
														<div className="errormessage">
															{this.state.emailErrorMsg}
														</div>

														<div className="continue-btn">
															<button
																type="submit"
																className="button1 btn standby-button-gradient standby-button-gradient-blue"
															>
																<Trans i18nKey="findcareoption.Covid.Continue_text">
																	Continue
																</Trans>
															</button>
														</div>

														<p
															className="cancel"
															onClick={() => {
																history.goBack();
															}}
														>
															<Trans i18nKey="userregistration.cancel">
																Cancel
															</Trans>
														</p>
													</div>
												</div>
												<div className="w-col w-col-6 w-col-tiny-tiny-stack">
													<img src={create} className="t-img" />
												</div>
											</div>
										) : (
											<div id="sentEmail">
												<div className="column w-col w-col-1 w-col-tiny-tiny-stack"></div>
												<div className="column-2 w-col w-col-5 w-col-tiny-tiny-stack">
													<div>
														<span id="createaccount">
															<Trans i18nKey="userregistration.step-1verifyemail">
																Please check your e-mail to verify your account
																and continue setup
															</Trans>
														</span>
													</div>
												</div>
												<div className="w-col w-col-6 w-col-tiny-tiny-stack">
													<img src={create} className="t-img" />
												</div>
											</div>
										)}
									</LoadingScreen>
								</div>
							)}
						</Form>
					</div>
				)}

				<Modal
					isOpen={state.showExistsModal}
					contentLabel="customStyles"
					className="ReactModal__Content_triagepopup"
					overlayClassName="ReactModal__Overlay_triagepopup"
				>
					<label className="label-header">
						<Trans i18nKey="userregistration.alert">ALERT</Trans>
					</label>
					<label className="label-header">
						<Trans i18nKey="userregistration.emailexists-msg1">
							An account with email address{" "}
						</Trans>
						'
						{state.triageRequest.mailValidation &&
							state.triageRequest.mailValidation.email
							? state.triageRequest.mailValidation.email.trim()
							: ""}
						'
						<Trans i18nKey="userregistration.emailexists-msg2">
							{" "}
							already exists. Please click
						</Trans>{" "}
						<span className="sign" onClick={(e) => actions.startAzureLogin()}>
							<Trans i18nKey="userregistration.emailexists-login">log in</Trans>
						</span>{" "}
						<Trans i18nKey="userregistration.emailexists-msg3">
							to continue using the service. If you would like to reset your
							password, please click on the forgot password link on login
							screen.
						</Trans>
					</label>
					<div className="pop_button">
						<button
							type="submit"
							className="popup-ok"
							onClick={(e) => {
								this.callSetStateModal(setState, false);
							}}
						>
							<Trans i18nKey="userregistration.emailexists-okbtn">Ok</Trans>
						</button>
					</div>
				</Modal>

			</div>
		);
	}
}
export default Create;
